export default __webpack_public_path__ + "static/media/profile.e6b47837.jfif";